import React, { useContext } from 'react'
import './style.scss'
import Button from '../../components/Button'
import CarImg from '../../assets/images/car-blue.png'
import { AppContext } from '../../store'

const toPlans = () => {
    document.getElementById("home").scrollIntoView()
}

export default function SectionIWant() {
    const { state } = useContext(AppContext)

    return (
        <section className="container-section-i-want">
            <div className="container-icon-text">
                <div className="icon">
                    <img alt="Carro" width="100%" src={CarImg} />
                </div>
                <div className="container-description">
                    <p>Conheça um mundo sem filas e sem perda de tempo.</p>
                    <p>E o melhor: com {state.mainBonus} mensalidades grátis.</p>
                    <div className="container-btn">
                        <Button onClick={toPlans} text="Peça já" />
                    </div>
                </div>
            </div>
        </section>
    )
}